import {
    FETCH_MESSAGE_EVENTS_REQUEST,
    FETCH_MESSAGE_EVENTS_SUCCESS,
    FETCH_MESSAGE_EVENTS_FAILURE,
    UPDATE_MESSAGE_EVENT_REQUEST,
    UPDATE_MESSAGE_EVENT_SUCCESS,
    UPDATE_MESSAGE_EVENT_FAILURE
  } from './../action/communicationChannel';
  
  const initialState = {
    loading: false,
    messageEvents: {},
    error: null
  };
  
  const messageEventsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MESSAGE_EVENTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      case FETCH_MESSAGE_EVENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          messageEvents: {
            ...state.messageEvents,
            [action.payload.relatedEntity]: action.payload
          }
        };
      case FETCH_MESSAGE_EVENTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.error
        };
      case UPDATE_MESSAGE_EVENT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      case UPDATE_MESSAGE_EVENT_SUCCESS:
        return {
          ...state,
          loading: false,
          messageEvents: {
            ...state.messageEvents,
            [action.payload.id]: action.payload  
          }
        };
      case UPDATE_MESSAGE_EVENT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.error
        };
      default:
        return state;
    }
  };
  
  export default messageEventsReducer;
  